import { createSelector } from '@ngrx/store';

import { getBackState, IBackState } from '../back.state';
import { BackBckpFeatureKey, IBackBckpState, EntityVolumetry } from './bckp.state';

const getBackBckpState = createSelector(
    getBackState,
    (state: IBackState) => state[BackBckpFeatureKey]
);

// ── Widget ────────────────────────────────────────────────────────────────────

export const getBackBckpWidget = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.widget
);
export const getBackBckpWidgetIsLoading = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.widgetIsLoading
);
export const getBackBckpWidgetIsLoaded = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.widgetIsLoaded
);
export const getBackBckpWidgetIsOups = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.widgetIsOups
);

// ── Detail Volumetry ────────────────────────────────────────────────────────────────────

export const getBackBckpEntities = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.entities
);
export const getBackBckpMonths = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.months
);
export const getBackBckpDetailIsLoading = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.detailIsLoading
);
export const getBackBckpDetailIsLoaded = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.detailIsLoaded
);
export const getBackBckpDetailIsOups = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.detailIsOups
);
export const getBackBckpRequestedMonths = createSelector(
    getBackBckpState,
    (state: IBackBckpState) => state.requestedMonths
);

/** Column totals: month key → sum of all entity TB values */
export const getBackBckpMonthTotals = createSelector(
    getBackBckpEntities,
    getBackBckpMonths,
    (entities: EntityVolumetry[], months: string[]): { [month: string]: number } => {
        const totals: { [month: string]: number } = {};
        months.forEach(m => {
            totals[m] = entities.reduce((s, e) => s + (e.monthly[m] ?? 0), 0);
        });
        return totals;
    }
);

/** Grand total TB across all entities and all months */
export const getBackBckpGrandTotal = createSelector(
    getBackBckpEntities,
    (entities: EntityVolumetry[]): number =>
        entities.reduce((s, e) => s + (e.total ?? 0), 0)
);
